import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

import useStyles from './styles';

function HelperSkeleton({ dragActive }) {
  const classes = useStyles();

  return (
    <>
      {[...Array(4).keys()].map((row) => (
        <Box className={classes.rootRow} key={`skeleton-table-resume-row-${row}`}>
          <Box className={classes.headerRow}>
            <Box className={classes.contentLeftRow}>
              {dragActive && <Skeleton height={24} variant="rectangular" width={24} />}
              <Box>
                <Box mb={1}>
                  <Skeleton height={40} variant="text" width={200} />
                </Box>
                <Box className={classes.wrapperTimesRow}>
                  {[...Array(2).keys()].map((time) => (
                    <Skeleton height={20} key={`skeleton-table-resume-row-time-${time}`} variant="text" width={120} />
                  ))}
                </Box>
              </Box>
            </Box>

            <Box className={classes.contentRightRow}>
              <Box className={classes.providersRow}>
                {[...Array(4).keys()].map((provider) => (
                  <Skeleton
                    height={30}
                    key={`skeleton-table-resume-row-provider-${provider}`}
                    variant="circular"
                    width={30}
                  />
                ))}
              </Box>
              <Skeleton height={24} variant="rectangular" width={6} />
            </Box>
          </Box>
        </Box>
      ))}
    </>
  );
}

HelperSkeleton.propTypes = {
  dragActive: PropTypes.bool,
};

export default HelperSkeleton;
